// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0e8ca0b0] .modalOpenStatus .modalDialog{height:calc(100% - 3.5rem)}[data-v-0e8ca0b0] .modalOpenStatus .modalDialog .modalContent.contentScroll{max-height:100%;overflow:auto}[data-v-0e8ca0b0] .modalOpenStatus .modalDialog .modalContent.contentScroll .modal-body{overflow:auto}", ""]);
// Exports
module.exports = exports;
